module.exports = __webpack_public_path__ + "static/media/SG.b9b7f0bc.jpg";